// this file is @generated

export enum EndpointDisabledTrigger {
  Manual = "manual",
  Automatic = "automatic",
}

export const EndpointDisabledTriggerSerializer = {
  _fromJsonObject(object: any): EndpointDisabledTrigger {
    return object;
  },

  _toJsonObject(self: EndpointDisabledTrigger): any {
    return self;
  },
};
